import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';

const PUBLIC_ROUTES = ['/mercado'];

/**
 * Interceptor que agrega el token JWT a todas las peticiones HTTP
 * y maneja respuestas 401 (token expirado/inválido)
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const token = localStorage.getItem('comex360_token');
  
  let request = req;
  if (token) {
    request = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
  
  return next(request).pipe(
    tap({
      error: (error) => {
        if (error.status === 401) {
          // No redirigir al login si estamos en una ruta pública
          const currentUrl = router.url;
          const isPublicRoute = PUBLIC_ROUTES.some(route => currentUrl.startsWith(route));
          if (isPublicRoute) return;

          localStorage.removeItem('comex360_token');
          localStorage.removeItem('comex360_user');
          router.navigate(['/auth/login']);
        }
      }
    })
  );
};
